import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_COMP_FIN_REQUEST, fetchCompFinancialFailure, fetchCompFinancialSuccess } from "../actions/companyFinancialsActions";
import { fetchCompanyFinancials } from "../../../services/accIqService";


// Worker Saga
function* fetchCompFinancialSaga() {
  try {
    const payload = yield select(state=>state?.companyFinancialsReducer?.payload);
    const {accountName,ticker} = payload;
    const data = yield call(fetchCompanyFinancials, accountName,ticker);
    yield put(fetchCompFinancialSuccess(data));
  } catch (error) {
    yield put(fetchCompFinancialFailure(error.message));
  }
}

// Watcher Saga
export function* watchfetchCompFinancial() {
  yield takeLatest(FETCH_COMP_FIN_REQUEST, fetchCompFinancialSaga);
}
